import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { compose } from 'recompose'

import { RoleChange } from 'containers/forms/roles'
import { Form } from 'components/layout'
import { PersonalBlock, AddressBlock } from 'components/sections/common'
import { FormButton, FloatingBar } from 'components/misc'
import { ContactOverview, ContactRestrictions } from 'components/sections/contacts'
import {
  apiContacts,
  apiCodeLists,
  apiPersons,
  apiParticipants, apiConfiguration
} from 'helpers/decorators/api'
import { meta, form } from 'helpers/decorators'
import { mapSchema } from 'models/contacts'
import { email } from 'utils/validation'
import DetailLoader from 'components/loaders/DetailLoader/DetailLoader'
import { asyncValidate } from 'models/persons/asyncValidate'
import { connect } from 'react-redux'
import { checkEmail } from '../../../redux/modules/api/asyncValidations'
import { CONFIGURATION_KEYS } from '../../../constants/enums'

const validate = values => ({
  email: email(get(values, 'email'))
})

const enhance = compose(
  meta({
    title: 'Office detail'
  }),
  apiContacts({
    detail: true
  }),
  apiCodeLists([
    'titles',
    'phoneTypes',
    'organizationContactReasonsOfDeletionTypes'
  ]),
  apiPersons({
    updateContactRoles: true
  }),
  apiParticipants(),
  apiConfiguration({
    getValues: [
      CONFIGURATION_KEYS.awardStaffRegistrationEmailAddress2.id,
      CONFIGURATION_KEYS.awardStaffContactDateOfBirth.id,
      CONFIGURATION_KEYS.awardStaffRegistrationPhone.id,
      CONFIGURATION_KEYS.awardStaffRegistrationTitle.id,
      CONFIGURATION_KEYS.awardStaffRegistrationMiddleName.id,
      CONFIGURATION_KEYS.awardStaffRegistrationAddressLine2.id,
      CONFIGURATION_KEYS.awardStaffRegistrationAddressLine1.id,
      CONFIGURATION_KEYS.awardStaffRegistrationAddressCity.id,
      CONFIGURATION_KEYS.awardStaffRegistrationAddressZipCode.id,
      CONFIGURATION_KEYS.awardStaffRegistrationAddressRegion.id,
      CONFIGURATION_KEYS.awardStaffRegistrationAddressCountry.id,
      CONFIGURATION_KEYS.awardStaffRegistrationRole.id,
      CONFIGURATION_KEYS.awardStaffRegistrationGender.id
    ]
  }),
  connect(() => ({ auth }) => ({
      activeOrganizationId: auth.organization.id
    }),
    { checkEmail }),
  form({
    form: 'detail-contact-form',
    initialProps: 'contacts.detail',
    initialPropsMapper: mapSchema,
    disableHook: true,
    validate,
    asyncValidate
  })
)

class ContactDetail extends Component {
  static propTypes = {
    codeLists: PropTypes.object.isRequired,
    persons: PropTypes.object.isRequired,
    contacts: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    sendRecoveryPassword: PropTypes.func.isRequired,
    changePersonState: PropTypes.func.isRequired,
    onUpdateContact: PropTypes.func.isRequired,
    onDeleteContact: PropTypes.func.isRequired,
    onDeactivateAccount: PropTypes.func.isRequired,
    modal: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
    addPersonRole: PropTypes.func.isRequired,
    editPersonRole: PropTypes.func.isRequired,
    deletePersonRole: PropTypes.func.isRequired,
    getInfoAboutPersonRole: PropTypes.func.isRequired,
    fetchOrganizationContactAllowedRoles: PropTypes.func.isRequired,
    getPersonRoles: PropTypes.func.isRequired,
    pristine: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    activeOrganizationId: PropTypes.number.isRequired,
    configuration: PropTypes.object.isRequired
  }

  render() {
    const {
      codeLists,
      persons,
      handleSubmit,
      onUpdateContact,
      onDeleteContact,
      change,
      contacts,
      addPersonRole,
      editPersonRole,
      deletePersonRole,
      getInfoAboutPersonRole,
      pristine,
      submitting,
      activeOrganizationId
    } = this.props

    const loading = contacts.loading

    const showSecondaryEmail = this.props.isOrgConfigurationTrue(activeOrganizationId, CONFIGURATION_KEYS.awardStaffRegistrationEmailAddress2.id)

    const showPhone = this.props.isOrgConfigurationTrue(activeOrganizationId, CONFIGURATION_KEYS.awardStaffRegistrationPhone.id)

    const showMiddleName = this.props.isOrgConfigurationTrue(activeOrganizationId, CONFIGURATION_KEYS.awardStaffRegistrationMiddleName.id)

    const showDateOfBirth = this.props.isOrgConfigurationTrue(activeOrganizationId, CONFIGURATION_KEYS.awardStaffContactDateOfBirth.id)

    const showAddressLine1 = this.props.isOrgConfigurationTrue(activeOrganizationId, CONFIGURATION_KEYS.awardStaffRegistrationAddressLine1.id)

    const showAddressLine2 = this.props.isOrgConfigurationTrue(activeOrganizationId, CONFIGURATION_KEYS.awardStaffRegistrationAddressLine2.id)

    const showCity = this.props.isOrgConfigurationTrue(activeOrganizationId, CONFIGURATION_KEYS.awardStaffRegistrationAddressCity.id)

    const showZipCode = this.props.isOrgConfigurationTrue(activeOrganizationId, CONFIGURATION_KEYS.awardStaffRegistrationAddressZipCode.id)

    const showRegion = this.props.isOrgConfigurationTrue(activeOrganizationId, CONFIGURATION_KEYS.awardStaffRegistrationAddressRegion.id)

    const showCountry = this.props.isOrgConfigurationTrue(activeOrganizationId, CONFIGURATION_KEYS.awardStaffRegistrationAddressCountry.id)

    const showAddressBlock = showAddressLine1 || showAddressLine2 || showCity || showZipCode || showRegion || showCountry


    return (
      <Form
        onSubmit={handleSubmit(fields =>
          onUpdateContact(get(contacts, 'detail.person.id'), fields, { isMfaChanged: get(fields, 'isMfaEnabled') !== get(contacts.detail, 'person.isMfaEnabled') })
        )}
        loading={loading}
        contentLoader={<DetailLoader modulesCount={3} withHeavyForm />}
      >

        <div className="row">
          <div className="col-xs-6">
            <PersonalBlock
              titles={codeLists.titles.list}
              phoneTypes={codeLists.phoneTypes.list}
              data={contacts.detail}
              change={change}
              personState={get(contacts, 'detail.personState')}
              migratedEmail={get(contacts, 'detail.migratedContactEmail')}
              decoPersonUpdate="contactDetail"
              canChangeEmail={get(contacts, 'detail.person.hasLogin')}
              disableEmail={get(contacts, 'detail.person.hasLogin')}
              personId={get(contacts, 'detail.person.id')}
              isOrganizationContact
              showSecondaryEmail={showSecondaryEmail}
              showTertiaryEmail={showSecondaryEmail}
              showMiddleName={showMiddleName}
              showPhone={showPhone}
              showPhoneType
              showDateOfBirth={showDateOfBirth}
            />

            {showAddressBlock && <AddressBlock
              change={change}
              formPrefix="address"
              withCountry
              showAddressLine1={showAddressLine1}
              showAddressLine2={showAddressLine2}
              showCity={showCity}
              showZipCode={showZipCode}
              showRegion={showRegion}
              showCountry={showCountry}
            />}
          </div>

          <div className="col-xs-6">
            <ContactOverview
              data={contacts.detail}
              onDeleteContact={onDeleteContact}
              modal={this.props.modal}
              sendRecoveryPassword={this.props.sendRecoveryPassword}
              changePersonState={this.props.changePersonState}
              onDeactivateAccount={this.props.onDeactivateAccount}
              orgContactDeletionTypes={
                codeLists.organizationContactReasonsOfDeletionTypes.list
              }
              persons={persons}
            />

            <ContactRestrictions
              data={contacts.detail}
              persons={persons}
            />

            <RoleChange
              loading={loading}
              data={contacts.detail}
              persons={persons}
              roleTypes={contacts.allowedRoles}
              addPersonRole={addPersonRole}
              editPersonRole={editPersonRole}
              deletePersonRole={deletePersonRole}
              getInfoAboutPersonRole={getInfoAboutPersonRole}
              fetchOrganizationContactAllowedRoles={
                this.props.fetchOrganizationContactAllowedRoles
              }
              getPersonRoles={this.props.getPersonRoles}
            />
          </div>
        </div>

        <FloatingBar>
          <FormButton
            pristine={pristine}
            intlKey="button.save"
            isLoading={submitting}
          >
            Save
          </FormButton>
        </FloatingBar>
      </Form>
    )
  }
}

export default enhance(ContactDetail)
